import React from 'react'
import { BACKEND_URL } from '../../const/Constant'
import styles from './expo.module.css'

export default function ExpoLibrary({el, setShowModal, index, setOpenedIndex}) {

    const open = () => {
        setShowModal(true)
        setOpenedIndex(index)
    }


  return (
    <div className={styles['each-image-div']} onClick={open}>
        <div className={styles['image-div']}>
            <img src={BACKEND_URL + el.image} alt='expo-image'/>
        </div>
    </div>
  )
}
